import { InputLabel, MenuItem } from '@mui/material';
import { AxiosResponse } from 'axios';
import { memo, useMemo } from 'react';
import { __ANPR_PERSON_API_URL__ } from 'shell/constants/environment';
import { useHttpFetch } from 'shell/hooks/use-http-fetch';
import { HttpResponseList } from 'shell/models/http-response';
import { ItemVM } from 'shell/view-models/item';
import { PmiSelect } from '../pmi-select';
import { PmiFormControl } from '../pmi-select/pmi-form-control';

interface TypeVoidCivilUnionListComponentProps {
  disabled?: boolean;
  value: string;
  onChange: (typeVoidCivilUnion?: string) => void;
  error?: boolean;
  required?: boolean;
  label?: string;
  id?: string;
  filterList?: (items: Array<ItemVM>) => Array<ItemVM>;
}

type Key = {
  codice: string;
};

interface TypeVoidCivilUnion {
  key: Key;
  descrizione: string;
}

const TypeVoidCivilUnionListComponent = ({
  disabled,
  onChange,
  required,
  value,
  error,
  label = 'Tipo cessazione unione civile',
  id = 'typeVoidCivilUnion',
  filterList,
}: TypeVoidCivilUnionListComponentProps): React.ReactElement => {
  const [typeVoidCivilUnion] = useHttpFetch<HttpResponseList<TypeVoidCivilUnion>, Array<ItemVM>>(
    `${__ANPR_PERSON_API_URL__}/tipo-cessazione-unione`,
    {
      onBootstrap: true,
      initialData: [],
      transformer: (response: AxiosResponse<HttpResponseList<TypeVoidCivilUnion>>) => {
        const { data } = response;

        return data?.payload.list.map((item) => ({
          id: item.key.codice?.toString(),
          value: item.descrizione,
        })) as Array<ItemVM>;
      },
    }
  );

  const list = (typeVoidCivilUnion.data as Array<ItemVM>) || [];

  const idTag = `${id}-${label}`;

  const listFiltered = useMemo(() => {
    if (filterList) {
      return filterList(list);
    }
    return list;
  }, [filterList, list]);

  return (
    <PmiFormControl fullWidth>
      <InputLabel error={error} disabled={disabled} id={idTag}>
        {required ? `${label} *` : label}
      </InputLabel>
      <PmiSelect
        labelId={idTag}
        id={id}
        name={id}
        value={value}
        label={required ? `${label} *` : label}
        onChange={(event) => {
          const selectedValue = event.target.value;
          onChange(selectedValue);
        }}
        disabled={disabled}
        error={error}
      >
        <MenuItem value="">
          <em>Nessuno</em>
        </MenuItem>
        {listFiltered?.map((item: ItemVM) => (
          <MenuItem key={item.id} value={item.id}>
            {item.value}
          </MenuItem>
        ))}
      </PmiSelect>
    </PmiFormControl>
  );
};

TypeVoidCivilUnionListComponent.displayName = 'Type void civil union List component';

const TypeVoidCivilUnionList = memo(TypeVoidCivilUnionListComponent);

export default TypeVoidCivilUnionList as typeof TypeVoidCivilUnionListComponent;
